import { FC, useState } from 'react';

import { Box, Table, TableContainer } from '@mui/material';
import clsx from 'clsx';
import { GANTT_CHART_CONTAINER } from 'constants/ids';

import { GANTT_MONTH_WIDTH } from 'components/OnePageTemplates/common/GanttChart/constants/ganttChart';
import { STYLE_VARIANTS } from 'components/OnePageTemplates/interfaces/variants';

import { IGanttTableProps as IProps } from './types';
import { GanttChartBody } from '../GanttChartBody';
import { GanttChartHeader } from '../GanttChartHeader';
import { GanttChartLegend } from '../GanttChartLegend';

import styles from './GanttTable.module.scss';

export const GanttTable: FC<IProps> = ({ startDate, finishDate, chartData, variant }) => {
  const [monthWidth, setMonthWidth] = useState(GANTT_MONTH_WIDTH);

  return (
    <>
      <GanttChartLegend variant={variant} />
      <Box
        className={clsx(styles.wrapper, {
          [styles.outlined]: variant === STYLE_VARIANTS.OUTLINED,
        })}
      >
        <TableContainer className={styles.tableWrapper} id={GANTT_CHART_CONTAINER}>
          <Table>
            <GanttChartHeader
              startDate={startDate}
              endDate={finishDate}
              monthWidth={monthWidth}
              setMonthWidth={setMonthWidth}
              variant={variant}
            />
            <GanttChartBody chartData={chartData} monthWidth={monthWidth} variant={variant} />
          </Table>
        </TableContainer>
      </Box>
    </>
  );
};
